import { Keyboard, SignOut, Translate } from "@phosphor-icons/react";
import { createAction } from "~/actions/registry";
import type { Action } from "~/actions/types";
import { i18n, SUPPORTED_LANGUAGES } from "~/foundation/i18n";

const section = (ctx: { t: (key: string) => string }) => ctx.t("Account");

const languageActions: Action[] = SUPPORTED_LANGUAGES.map((language) =>
  createAction({
    id: `language.${language.code}`,
    name: () => language.label,
    section,
    keywords: `language locale ${language.code}`,
    selected: () => i18n.resolvedLanguage === language.code,
    // SLATE-LATER: also PATCH the viewer profile so the choice follows the account.
    perform: () => {
      void i18n.changeLanguage(language.code);
    },
  }),
);

export const languageAction = createAction({
  id: "language",
  name: (ctx) => ctx.t("Language"),
  section,
  icon: Translate,
  keywords: "language locale hebrew english rtl",
  children: languageActions,
});

export const keyboardShortcutsAction = createAction({
  id: "settings.shortcuts",
  name: (ctx) => ctx.t("Keyboard shortcuts"),
  section,
  icon: Keyboard,
  shortcut: ["?"],
  keywords: "keys bindings help",
  perform: (ctx) => ctx.shell.getState().openDialog({ kind: "shortcuts" }),
});

export const signOutAction = createAction({
  id: "auth.signOut",
  name: (ctx) => ctx.t("Sign out"),
  section,
  icon: SignOut,
  keywords: "logout leave exit",
  visible: (ctx) => ctx.viewer !== undefined,
  perform: async (ctx) => {
    await ctx.api.auth.logout();
    // The router re-asks the API for a session on every navigation, so this is enough.
    ctx.navigate("/login");
  },
});

export const settingsActions: Action[] = [languageAction, keyboardShortcutsAction, signOutAction];

export { languageActions };
